<template>
  <el-dialog
    class="reserve-record-details"
    :title="title"
    v-dialogDrag
    width="700px"
    :visible.sync="showDetails"
    @close="close"
  >
    <el-tabs v-model="activeName">
      <el-tab-pane label="报告详情" name="first">
        <div>
          <span>抓拍图片</span>
          <div
            v-if="reportDetails.length > 0"
            style="overflow: auto; height: 100px"
          >
            <div
              v-for="(item, index) in reportDetails"
              :key="index"
              style="display: inline-block; width: 22%; margin: 10px 3% 10px 0"
            >
              <!-- item.indexOf('http')==-1?Bus.imgPath(item): -->
              <img
                :src="item"
                alt=""
                style="width: 100%; height: 70px;cursor:pointer;"
                @click="showViewer(item, $event)"
              />
            </div>
          </div>
          <div v-else style="padding: 20px; text-align: center">
            暂无抓拍图片
          </div>
        </div>
        <div>
          <el-form :model="ruleForm" ref="ruleForm">
            <el-form-item prop="textarea">
              <!-- <span style="color:red">* </span> -->
              <span>报告内容</span>
              <div>
                <el-input
                  type="textarea"
                  :rows="5"
                  :readonly="!btn"
                  :maxlength="200"
                  :show-word-limit="true"
                  v-model="textarea"
                >
                </el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item class="dialog-footer" style="text-align:right">
                <el-button type="info" v-if="btn" @click="submitData">提交报告</el-button>
                <el-button type="info" v-if="btn" @click="close">取消</el-button>
                <el-button type="info" v-else @click="close">关闭</el-button>
              </el-form-item> -->
          </el-form>
          <!-- <span>报告内容</span>
            <div style="margin-top:10px">
              <el-input
                type="textarea"
                :rows="5"
                :readonly="!btn"
                placeholder=""
                v-model="textarea">
              </el-input>
            </div> -->
        </div>
      </el-tab-pane>
      <el-tab-pane label="执行明细" name="second">
        <div style="padding: 15px 0 0 20px; max-height: 400px; overflow: auto">
          <el-timeline direction="vertical">
            <!-- :type="item.status == '1' ? 'primary' : ''" -->
            <el-timeline-item
              v-for="(item, index) in stepList"
              :key="index"
              type="primary"
              :timestamp="
                item.operateTime
                  ? getTime(item.operateTime, 'yyyy-MM-dd hh:mm:ss')
                  : ''
              "
            >
              {{ item.type | dic("SENU073007") }}
              <template>
                <div style="position: absolute; left: 100px; top: 0px">
                  <span
                    style="border: none; color: #00e8bb; cursor: pointer"
                    v-if="item.type && item.type != '99' && item.type != '-1'"
                    @click.stop="getDetailsLists(item)"
                    >详情</span
                  >
                </div>
              </template>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" v-if="btn" @click="close">取消</el-button>
      <el-button type="info" v-else @click="close">关闭</el-button>
      <el-button v-if="btn" type="primary" @click="submitData"
        >提交报告</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import store from "@src/common/lib/store";
import i18n from "@src/common/lib/i18n";
import { formatTimeToStr } from "../filter/dateUtils";
import { Dates, Dic, Cache, Bus } from "$utils";
import { api } from "../api";
import tableOption from "../const/table";
import stepOption from "../const/step";
export default {
  name: "reserveRecordDetails",
  props: {
    btn: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
    // activeName:{
    //   type:String,
    //   default:()=>{
    //     return 'first'
    //   }
    // },
    textarea: {
      type: String,
      default: () => {
        return "";
      },
    },
    reportDetails: {
      type: Array,
      default: () => {
        return [];
      },
    },
    stepList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      Bus,
      ruleForm: {
        textarea: "",
      },
      text: "",
      showDetails: false,
      activeName: "first",
      reportDetails1: [],
    };
  },
  mounted() {
    // console.log('props1111', this.stepList)
  },
  methods: {
    // imgPath (value) {
    //   if (value.indexOf('http') != -1) {
    //     return value
    //   } else {
    //     console.log(Bus.imgPath(value))
    //     return Bus.imgPath(value)
    //   }
    // },
    showViewer(src, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    close() {
      this.showDetails = false;
      this.activeName = "first";
    },
    submitData() {
      // if (!this.textarea) {
      //   this.$message.warning('请输入报告内容!')
      //   return false
      // } else {
      this.$emit("submitData", this.textarea);
      // }
    },
    callback(data, orm, code, mock, url, params, dataAll) {
      if (data.length > 0) {
        this.stepHistoryList = data;
        let ary = [];
        data.map((val, index) => {
          if (index == 0) {
            for (const key in val) {
              for (const item in orm) {
                if (key == item) {
                  let obj = {};
                  if (
                    typeof orm[item] == "object" &&
                    orm[item].type == "date"
                  ) {
                    obj["label"] = orm[item].label;
                    obj["prop"] = key;
                    obj["search"] = false;
                    obj["span"] = 12;
                    obj["formatter"] = function (row, value) {
                      return formatTimeToStr(value, "yyyy-MM-dd");
                    };
                  } else if (
                    typeof orm[item] == "object" &&
                    orm[item].type == "status"
                  ) {
                    // console.log('status_',orm[item])
                    obj["label"] = orm[item].label;
                    obj["prop"] = key;
                    obj["search"] = false;
                    obj["span"] = 12;
                    orm[item].list.map((data_) => {
                      if (data_.code == code) {
                        let rules = data_.rules;
                        obj["formatter"] = function (row, value) {
                          // console.log('data_value',value)
                          let str = "";
                          rules.map((item_) => {
                            console.log("item_", item_.value);
                            console.log("value_", value);
                            if (item_.value == value) {
                              str = item_.label;
                            }
                          });
                          console.log("str", str);
                          return str;
                        };
                      }
                    });
                  } else {
                    obj["label"] = orm[item];
                    obj["prop"] = key;
                    obj["search"] = false;
                    obj["span"] = 12;
                  }
                  ary.push(obj);
                }
              }
            }
          }
        });
        this.$emit("showStepDetails", ary, data, url, params, dataAll);
      } else {
        console.log("code", code);
        console.log("mock", mock);
        let ary = [];
        for (const key in mock) {
          if (key == code) {
            for (const item in mock[key].mock[0]) {
              ary.push({
                label: mock[key].mock[0][item],
                prop: item,
                search: false,
              });
            }
          }
        }
        this.$emit("showStepDetails", ary, null, url, params, dataAll);
      }
    },
    getTime(time, type) {
      return formatTimeToStr(time, type);
    },
    callbackYhj(data) {
      // 原先数据结构
      // [{
      // 操作人: "叶海军"
      // 操作时间: "2021-04-30 16:25:45"
      // 新级别: "Ⅱ级"
      // 旧级别: "Ⅰ级"
      // }]
      let ary = [];
      data.map((val, index) => {
        // 拿第一个对象的属性
        if (index == 0) {
          for (const key in val) {
            let obj = {};
            obj["label"] = key;
            obj["prop"] = key;
            obj["search"] = false;
            obj["span"] = 12;
            ary.push(obj);
          }
        }
      });
      this.$emit("showStepDetails", ary, data);
    },
    getDetailsLists(data) {
      // console.log(data)
      this.$fetch(api.getSubRecordDetail, {
        emergencySubRecordCode: data.emergencySubRecordCode,
      }).then((res) => {
        if (res.success) {
          if (!res.returnObj) {
            this.$message.warning("暂无数据，稍后再试");
            return;
          }
          // 返回格式化数据
          this.callbackYhj(res.returnObj);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    getDetailsList(data) {
      this.activeName = "second";
      let planStepCode = data.planStepCode;
      let url = "";
      let params = null;
      let code = {
        20200330000001: {
          url: "/bas/emergency/queryBatchPushSMSRecord.json",
          params: {
            emergencyProcessID: data.emergencyProcessID,
            parkId: "200000001",
            pageNum: 1,
            pageSize: 10,
          },
          mock: [
            {
              nickName: "姓名",
              phone: "电话",
              status: "状态",
            },
          ],
        },
        20200330000003: {
          url: "/bas/emergency/queryTaskDetail.json",
          params: {
            emergencyProcessID: data.emergencyProcessID,
            parkId: "200000001",
            pageNum: 1,
            pageSize: 10,
          },
          mock: [
            {
              nickName: "姓名",
              phone: "电话",
              status: "状态",
            },
          ],
        },
        20200330000006: {
          url: "/bas/emergency/querySceneProcessRecord.json",
          params: {
            emergencyProcessID: data.emergencyProcessID,
            parkId: "200000001",
          },
          mock: [],
        },
      };
      for (const key in code) {
        if (data.planStepCode == key) {
          // console.log('val',code[key].url)
          url = code[key].url;
          params = code[key].params;
        }
      }
      let orm = {
        // optTime:{
        //   label:'启用时间',
        //   type:'date'
        // },
        status: {
          label: "状态",
          type: "status",
          list: [
            {
              code: "20200330000006",
              rules: [
                {
                  label: "未完成",
                  value: 2,
                },
                {
                  label: "已完成",
                  value: 1,
                },
              ],
            },
            {
              code: "20200330000001",
              rules: [
                {
                  label: "成功",
                  value: "000000",
                },
                {
                  label: "失败",
                },
              ],
            },
            {
              code: "20200330000003",
              rules: [
                {
                  label: "未执行",
                  value: "10",
                },
                {
                  label: "执行中",
                  value: "20",
                },
                {
                  label: "待审核",
                  value: "30",
                },
                {
                  label: "完成",
                  value: "90",
                },
              ],
            },
          ],
        },
        phone: "电话",
        // operator:'操作人',
        // accountNumber:'账号',
        nickName: "姓名",
      };
      $.ajax({
        type: "post",
        headers: {
          ticket: store.getters.userInfo.access_token || "",
          locale: i18n.locale || "",
        },
        url,
        data: JSON.stringify(params),
        dataType: "json",
        contentType: "application/json",
        async: false,
        success: (data) => {
          console.log("success", data);
          this.callback(
            data.returnObj.list,
            orm,
            planStepCode,
            code,
            url,
            params,
            data
          );
        },
        error: (error) => {
          this.callback([], orm);
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>

.reserve-record-details {
  .elePatrol {
    width: 100%;
    height: 100%;
  }
  .el-step__description.is-success {
    color: #00e8bb;
  }
  .el-step__head.is-success {
    border-color: #00e8bb;
  }
  .el-tabs__content {
    overflow: auto;
    height: 300px;
  }
  li {
    list-style: none;
  }
}
</style>
